export { default as MultilingualWidget } from './MultilingualWidget';

export default (config) => config;
